import { STATUS_OPTIONS, statusMeta } from "@/lib/orderStatus";

export default function StatusSelect({ value, onChange, testId }) {
  const meta = statusMeta(value);
  return (
    <select
      data-testid={testId}
      value={value || "nowe"}
      onChange={(e) => onChange(e.target.value)}
      className={`text-xs font-bold rounded-full border px-2 py-1 cursor-pointer outline-none ${meta.cls}`}
    >
      {STATUS_OPTIONS.map((s) => (
        <option key={s.value} value={s.value} className="bg-white text-slate-800">
          {s.label}
        </option>
      ))}
    </select>
  );
}
